import { useContext } from 'react'

import { ZaiChatObserverContext } from './context'

export function useZaiChatObserver() {
  const context = useContext(ZaiChatObserverContext)

  if (!context) {
    throw new Error('useZaiChatObserver must be used within a ZaiChatObserverProvider')
  }

  return context
}
